import { APICallInterface } from 'app/scripts/services/sagas/types';

/**
 * This function sends a request to close\open a conversation
 * @param isReadOnly - True - Close the conversation, False - Open the conversation
 * @param conversationId - The conversation id: spotId_postId
 * @param postId Post Id to close\open
 */
export const setIsReadOnly = (
  isReadOnly: boolean,
  conversationId: string,
  postId: string
): APICallInterface => ({
  types: ['READ_ONLY_REQUEST', 'READ_ONLY_SUCCESS', 'READ_ONLY_FAILURE'],
  params: {
    method: 'POST',
    url: '/conversation/metadata/read_only',
    payload: {
      read_only: isReadOnly,
      conversation_id: conversationId
    },
    config: {
      headers: {
        'X-Post-Id': postId
      }
    }
  }
});
